import { UnshadowedElement, html } from "../lib/unshadowed.js";

/** Minimum horizontal travel, in pixels, before a touch counts as a swipe */
const SWIPE_THRESHOLD = 40;

/**
 * Render an image, or an array of images, as a carousel.
 */
export class ImageCarousel extends UnshadowedElement {
    static elementName() { return "image-carousel" }

    static properties = {
        images: { type: Array },
        alt: { type: String },

        index: { state: true, type: Number },
    };

    /** @type {Touch} Where the in-progress touch started */
    touchStart;

    constructor() {
        super();
        this.index = 0;
    }

    LastIndex() {
        return (this.images?.length ?? 0) - 1;
    }

    GoPrevious() {
        if (this.index > 0) this.index--;
    }

    GoNext() {
        this.index = (this.index + 1) % this.images.length;
    }

    TouchStart(event) {
        this.touchStart = event.changedTouches[0];
    }

    TouchEnd(event) {
        const dx = event.changedTouches[0].clientX - this.touchStart.clientX;
        const dy = event.changedTouches[0].clientY - this.touchStart.clientY;
        // Only count if swipe is big enough and mostly horizontal
        if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dy) > Math.abs(dx)) return;
        // Keeps the browser from also turning this swipe into a click, which would advance twice
        event.preventDefault();
        if (dx < 0) this.GoNext(); else this.GoPrevious();
    }

    render() {
        if (!this.images || this.images.length === 0) return null;
        if (this.images.length === 1) {
            return html`<img src="${this.images[0]}" alt="${this.alt}" />`;
        }
        const slides = this.images.map((image, i) => html`
            <div class="image-carousel__slide" aria-hidden="${i !== this.index}">
                <img src="${image}" alt="${this.alt}" draggable="false" />
            </div>`);
        return html`
            <div class="image-carousel__viewport" @click=${this.GoNext} @touchstart=${this.TouchStart} @touchend=${this.TouchEnd}>
                <div class="image-carousel__track"
                     style="transform: translateX(calc(${this.index * -100}%))">
                    ${slides}
                </div>
            </div>
            ${this.index > 0 ? html`
                <button type="button" class="button button-circle-m image-carousel__arrow image-carousel__arrow--previous" aria-label="Previous image" @click=${this.GoPrevious}>
                    <svg role="img" width="9" height="16" fill="none" viewBox="0 0 9 16" aria-hidden="true">
                        <path stroke="#042E53" stroke-miterlimit="10" stroke-width="1.5" d="M9 1 2 8l7 7" />
                    </svg>
                </button>` : null}
            ${this.index < this.LastIndex() ? html`
                <button type="button" class="button button-circle-m image-carousel__arrow image-carousel__arrow--next" aria-label="Next image" @click=${this.GoNext}>
                    <svg role="img" width="9" height="16" fill="none" viewBox="0 0 9 16" aria-hidden="true">
                        <path stroke="#042E53" stroke-miterlimit="10" stroke-width="1.5" d="m.5 14.6 7-7-7-7" />
                    </svg>
                </button>` : null}
        `;
    }
}
